<template lang="pug">
.spectrum
  .spectrumControls
    input.input(type="text" v-model="textInput" @keyup="getShades()")

  .spectrum-select(:style="{backgroundColor:textInput}")

    //- .spectrum-logo(:style="{color: this.pickerInput.hsl.l > 0.5 ? '#000' : '#fff'}")
    //-   AppIcon(name="logoSpectrum")
    .spectrum-picker
      no-ssr
        chrome-picker(v-model="pickerInput" disableAlpha)
        button.spectrum-picker-random.button.is-tiny(@click="randomize()") {{$t('randomColor')}}
  .spectrum-colors
    .dummyCopy
    .spectrum-colors-item(ref="colorItem" data-tooltip="Click to copy" v-for="shade in shades" :style="{ backgroundColor: shade.color, color: shade.textColor }" :class="{ 'is-active': selectedColor == shade.color }" @click="copyFn(shade.color)")
      p {{ shade.color }}

</template>

<style lang="stylus">
.app
  &.is-spectrum
    background: $clWhite

    .footer, .header
      display: none

.spectrum
  display: flex
  margin-left: -12vw
  margin-right: -12vw
  justify-content: flex-end

  +mq($until: 550px)
    display: block

  &-select
    width: 50%
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    height: 100vh
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    transition: 200ms background

    +mq($until: 550px)
      position: static
      min-height: 50vh
      padding: 40px
      text-align: center
      width: 100%
      height: auto

  &-colors
    width: calc(50% + 10px)
    display: flex
    justify-content: center
    flex-direction: column
    align-items: center
    justify-content: flex-end

    +mq($until: 550px)
      width: 100%

    &-item
      height: unitRes(30, 60)
      display: block
      width: 100%
      cursor: pointer
      position: relative
      display: inline-flex
      text-align: center
      justify-content: center
      align-items: center
      transition: 200ms
      cursor: pointer

      &:hover
        transform: scaleY(1.05, 1.05)
        box-shadow: 0px 0px 37px 0px rgba(0, 0, 0, 0.8)
        z-index: 3

      &.is-active
        transform: scaleY(1.05, 1.05)
        z-index: 2
        box-shadow: 0px 0px 37px 0px rgba(0, 0, 0, 0.8)

  &-picker
    position: relative

    .vc-chrome-body
      padding-bottom: 60px

    &-random.button
      position: absolute
      bottom: 16px
      left: 16px
      right: 16px
      width: calc(100% - 32px)
      display: block
      margin-bottom: 0

  &-logo
    margin: 0 0 40px

    .icon
      width: unitRes(235, 340)
      height: unitRes(60, 90)

.spectrumControls
  display: none

  .button
    white-space: nowrap

.dummyCopy
  position: absolute
  top: -9999px
  left: -9999px
</style>

<script>
// import Verte from 'verte';
// import 'verte/dist/verte.css';
import { Chrome } from 'vue-color';
import NoSSR from 'vue-no-ssr';
import { mapActions } from 'vuex';
import { generateSeoMeta } from '~/utils/seo';
import { copyToClipboard } from '~/utils/common';

let components = {
  'chrome-picker': Chrome,
  'no-ssr': NoSSR
};
export default {
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true }),
  meta: {
    theme: 'dark spectrum fixedHeader',
    logoText: '__NONE__'
  },
  data: () => ({
    inputColor: '',

    pickerInput: {
      hsl: { l: 0.2 }
    },
    shades: [],
    textInput: ''
  }),
  components: components,
  methods: {
    ...mapActions({
      success: 'alert/success'
    }),
    copyFn(val) {
      copyToClipboard(val);
      this.success(this.$t('copied'));
    },
    hexToRGB(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      if (result) {
        return {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        };
      } else {
        return null;
      }
    },
    rgbToHSL({ r, g, b }) {
      r /= 255;
      g /= 255;
      b /= 255;
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      let h = 0;
      let s = 0;
      let l = (max + min) / 2;

      if (max !== min) {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }

        h /= 6;
      }

      // function precisionRound(number, precision) {
      //   var factor = Math.pow(10, precision);
      //   return Math.round(number * factor) / factor;
      // }

      return { h, s, l };
    },
    hslToRGB({ h, s, l }) {
      var r, g, b;
      function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      }
      if (s === 0) {
        r = g = b = l; // achromatic
      } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;

        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }

      return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
      };
    },
    rgbToHEX({ r, g, b }) {
      return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },

    randomize() {
      let random = (this.inputColor = '#' + ((Math.random() * 0xffffff) << 0).toString(16));
      if (random.length < 7) {
        random += '2';
      }

      this.inputColor = this.textInput = random;
      this.getShades(random);
    },
    getShades(hex) {
      this.shades = [];
      if (!hex) {
        hex = this.textInput;
      }

      const rgb = this.hexToRGB(hex);
      const hsl = this.rgbToHSL(rgb);
      const lowerbound = [];
      for (let l = hsl.l; l <= 2; l += 0.03) {
        if (l > 1) {
          l = 1;

          const newRgb = this.hslToRGB({ h: hsl.h, s: hsl.s, l });

          const newHex = this.rgbToHEX(newRgb);
          lowerbound.push({ color: newHex, textColor: '#000' });
          break;
        }

        const newRgb = this.hslToRGB({ h: hsl.h, s: hsl.s, l });

        const newHex = this.rgbToHEX(newRgb);
        lowerbound.push({
          color: newHex,
          textColor: l > 0.5 ? '#000' : '#fff'
        });

        this.selectedColor = this.textInput.includes('#') ? this.textInput : `#${this.textInput}`;
      }

      const upperbound = [];
      for (let l = hsl.l - 0.03; l >= -1; l -= 0.03) {
        if (l < 0) {
          l = 0;
          const newRgb = this.hslToRGB({ h: hsl.h, s: hsl.s, l });
          const newHex = this.rgbToHEX(newRgb);
          upperbound.push({ color: newHex, textColor: '#fff' });
          break;
        }
        const newRgb = this.hslToRGB({ h: hsl.h, s: hsl.s, l });
        const newHex = this.rgbToHEX(newRgb);
        upperbound.push({
          color: newHex,
          textColor: l > 0.5 ? '#000' : '#fff'
        });
      }

      this.shades = [...upperbound.reverse(), ...lowerbound];
      this.$nextTick(() => {
        this.$refs.colorItem.forEach(el => {
          if (el.classList.contains('is-active')) {
            el.scrollIntoView({
              behavior: 'smooth'
            });
          }
        });
      });

      // console.log(this.$refs.colorItem);
    }
  },
  watch: {
    'pickerInput.hex'(to) {
      if (to) {
        this.getShades(to);
        this.selectedColor = this.pickerInput.hex.toLowerCase();
        this.textInput = this.pickerInput.hex.toLowerCase();
      }
    }
  },
  mounted() {
    this.randomize();
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Ranges",
    "pageDesc":"Get the hues and tints of any color you want. Combine them to have the perfect color mix for your next unique palette",
    "copied": "Copied to clipboard",
    "randomColor":"Random color"
  },
  "ar": {
    "pageTitle":"أطياف",
    "pageDesc":"احصل على الإصدارات الفاتحة أو الداكنة من أي لون تفضله. ادمجهم للحصول على مزيج ألوان مثالي للوحة ألوان  فريدة من نوعها.",
    "copied": "تم النسخ",
    "randomColor":"لون عشوائي"
  }
}
</i18n>
